"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ClockForward24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "clock-forward-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M17.3677512,7.98139896 L17.6921265,6.31263274 L19.2062924,6.60593072 C17.5338472,4.37259468 14.8893317,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 C16.9705627,21 21,16.9705627 21,12 L23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 C15.6585665,1 18.8999678,2.78609689 20.8998057,5.5338926 L21.209435,3.94017818 L22.8782012,4.26455347 L22.12,8.161 L21.981399,8.87820123 L17.3677512,7.98139896 Z", id: "Combined-Shape", fill: "#000000" }),
            react_1.default.createElement("polygon", { id: "Path-2", fill: "#000000", fillRule: "nonzero", points: "13 11.5 13 5 11 5 11 12.5 15.4 15.8 16.6 14.2" })));
}
function ClockForward24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ClockForward24Svg, Object.assign({}, svgProps)));
}
exports.default = ClockForward24;
//# sourceMappingURL=ClockForward24.js.map